export default __webpack_public_path__ + "static/media/1803.b7ece5ab.png";